// extracted by mini-css-extract-plugin
module.exports = {"referralContainer":"Referrals_referralContainer__zxcNo","referralButtons":"Referrals_referralButtons__2rSMF"};